import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { DocumentDetailStateProvider } from '../../../page';
import { ToolbarItemContainerProps } from './toolbarItemProps';
import { ReportingContainerBaseConfig } from '../../../base';
import { ToolbarItemController } from './toolbarItemInterface';
import { ToolbarFormValues } from './toolbarItemModel';
import { toJS } from 'mobx';
import { assert } from '@varos/util-typescript';
import { z } from 'zod';

export function createToolbarItemContainer(
    config: ReportingContainerBaseConfig,
    controller: ToolbarItemController
): React.FC<ToolbarItemContainerProps> {
    const {
        kernel: {
            infra: {
                optionParser: { useOptions },
            },
        },
        context: { useContext },
        pubsub,
    } = config;

    const UrlParamSchema = z.object({
        contentId: z.string(),
    });

    return config.state.document.subscribe(({ as: View, ...containerProps }) => {
        const context = useContext();

        const state = config.state.document.useState(context);

        // TODO centralize URL state
        const params = useOptions(UrlParamSchema);

        const form = useForm<ToolbarFormValues>({
            defaultValues: {
                ask: '',
            },
        });
        const props = controller.useProps(context, {
            values: form.watch(),
            form: {
                id: 'toolbar-item-ask-ai-form',
                form,
                async onSubmit(data) {
                    console.log(
                        'onSubmit',
                        data,
                        state.value.document.selection?.plaintext
                    );
                    form.reset({ ask: '' });
                    if (!state.value.document.selection) {
                        console.warn('No selection');
                        return;
                    }
                    await pubsub.dispatch({
                        kind: 'ask',
                        data: {
                            content: {
                                id: params.contentId,
                            },
                            text: data.ask,
                            selection: toJS(state.value.document.selection),
                        },
                    });
                    state.onChange({
                        ...state.value,
                        document: {
                            ...state.value.document,
                            selection: null,
                        },
                    });
                },
            },
            selection: state.value.document.selection
                ? {
                      plaintext: state.value.document.selection.plaintext,
                  }
                : null,
        });

        if (
            !state.value.document.selection ||
            state.value.document.selection.plaintext.trim() === ''
        ) {
            // TODO properly handle selection menu state. Menu visibility should be based
            // on the selection state, and not managed internally by tiptap editor
            return null;
        }
        return <View {...props} />;
    });
}
